export default __webpack_public_path__ + "static/media/vs.3a5a61fd.webp";